import loadGoogleMapsApi from 'load-google-maps-api';
import mapStyles from '../util/mapStyles';

export default {
    init() {
        // JavaScript to be fired on the contact page
        class mapViewer {
            constructor() {
                // get API key from template
                this.apiKey = document.querySelector('.office-location-listing').dataset.key;

                // if API key exists init map
                if (this.apiKey) {
                    this.googleMaps = false;
                    this.loadGoogleMaps();
                } else {
                    console.error('No api key loaded');
                }
            }

            loadGoogleMaps() {
                loadGoogleMapsApi({key: this.apiKey}).then((googleMaps) => {
                    this.googleMaps = googleMaps;
                    this.addCallbacks();
                });
            }

            addCallbacks() {
                let _this = this;

                $(".modal-map").each(function () {
                    $(this).on('show.bs.modal', function (e) {
                        _this.showMap(e, $(this));
                    })
                });
            }

            showMap(event, $element) {
                let $mapContainer = $('.modal-map__map', $element);

                let map = new this.googleMaps.Map($mapContainer.get(0), {
                    styles: mapStyles,
                    center: {
                        lat: $mapContainer.data('lat'),
                        lng: $mapContainer.data('lng'),
                    },
                    zoom: 15,
                });

                new this.googleMaps.Marker({
                    position: {
                        lat: $mapContainer.data('lat'),
                        lng: $mapContainer.data('lng'),
                    },
                    icon: this.getMarkerIcon(),
                    map: map,
                });
            }

            getMarkerIcon() {
                return {
                    path: "M 10.316406 29.394531 C 1.617188 17.050781 0 15.785156 0 11.25 C 0 5.035156 5.148438 0 11.5 0 C 17.851562 0 23 5.035156 23 11.25 C 23 15.785156 21.382812 17.050781 12.683594 29.394531 C 12.109375 30.203125 10.890625 30.203125 10.316406 29.394531 Z M 11.5 15.9375 C 14.144531 15.9375 16.292969 13.839844 16.292969 11.25 C 16.292969 8.660156 14.144531 6.5625 11.5 6.5625 C 8.855469 6.5625 6.707031 8.660156 6.707031 11.25 C 6.707031 13.839844 8.855469 15.9375 11.5 15.9375 Z M 11.5 15.9375",
                    fillColor: "#004BFF",
                    fillOpacity: 1,
                    strokeWeight: 0,
                    scale: 1,
                    anchor: new this.googleMaps.Point(12, 30),
                }
            }
        }

        new mapViewer();
    },
    finalize() {
        // JavaScript to be fired on the contact page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/contact.js